import React from 'react';
import funciones from '../../assets/funciones'
import './css/Header.css';
import logo from './img/logoMDH.png';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      width:0,
      height:0
    }
    this.onWindowResize = this.onWindowResize.bind(this)
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      this.forceUpdate();
    });
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  }
  componentWillUnmount() {
    this.unlisten();
    window.removeEventListener('resize', this.onWindowResize);
  }

  onWindowResize(){
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
    this.forceUpdate();
  }

  clickHandler(e, url){
    e.preventDefault();
    this.props.history.push(url);
  }

  cerrarSesion(){
    sessionStorage.clear();
    this.props.history.push('/');
  }

  menuDerecha(){
    const token = sessionStorage.getItem('token');
    if (token) {
      return(
        <span
          className="Opcion"
          style={{cursor:'pointer'}}
          onClick={()=>this.cerrarSesion()}
        >
          CERRAR SESIÓN
        </span>
      )
    } else {
      return(
        <a
          className="Opcion"
          href="/login"
          onClick={(e)=>this.clickHandler(e, "/login")}
        >
          INGRESAR
        </a>
      )
    }
  }

  render(){
    const {width, height} = this.state;
    const {menu} = this.props;
    if (width >= 500) {
      return(
        <div className="Header">
          <div className="Container">
            <a
              style={{height:'100%'}}
              href={'/'}
              onClick={(e)=>this.clickHandler(e, '/')}
            >
              <span className="Titulo" style={{fontSize:36, color:'white',textDecoration:'none'}}>
                Ministerio de
                <br/>
                Desarrollo Humano
              </span>
            </a>
            <div className="Main">
              {funciones.nivelAcceso(menu, sessionStorage.getItem('tipo')).map((item,index) => {
                return(
                  <a
                    className="Opcion"
                    href={item.url}
                    key={index}
                    onClick={(e)=>this.clickHandler(e, item.url)}
                  >
                    {item.titulo}
                  </a>
                )
              })}
            </div>
            <div className="Derecha">
              {this.menuDerecha()}
            </div>
          </div>
        </div>
      );
    } else {
      return(
        <div className="Header">
          <div className="Container">
            <a
              style={{height:'100%'}}
              href={'/'}
              onClick={(e)=>this.clickHandler(e, '/')}
            >
              <img
                src={logo}
                height={80}
                className="Logo"
                alt="Logo"
              />
            </a>
            <div className="Derecha">
              <span
                className="material-icons Accion"
                style={{marginRight:20, backgroundColor:'lightgrey', padding:'10px 12px'}}
                title="Menú"
                onClick={() => this.props.abrirMenu(funciones.nivelAcceso(menu, sessionStorage.getItem('tipo')))}
              > menu </span>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Header;
